var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 4C1.43269 4 0 5.43269 0 7.2V16C0 17.7673 1.43269 19.2 3.2 19.2H20.8C22.5673 19.2 24 17.7673 24 16V7.2C24 5.43269 22.5673 4 20.8 4H3.2Z",
    fill: "#6983D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4401 11.6C13.4401 14.2233 11.2911 16.35 8.64009 16.35C5.98912 16.35 3.84009 14.2233 3.84009 11.6C3.84009 8.97662 5.98912 6.84998 8.64009 6.84998C11.2911 6.84998 13.4401 8.97662 13.4401 11.6Z",
    fill: "#F6635F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1599 11.6C20.1599 14.2233 18.0109 16.35 15.3599 16.35C12.709 16.35 10.5599 14.2233 10.5599 11.6C10.5599 8.97662 12.709 6.84998 15.3599 6.84998C18.0109 6.84998 20.1599 8.97662 20.1599 11.6Z",
    fill: "#FFB548"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.9922C12.8886 14.1301 13.4399 12.9288 13.4399 11.6C13.4399 10.2712 12.8886 9.06991 11.9999 8.20782C11.1113 9.06991 10.5599 10.2712 10.5599 11.6C10.5599 12.9288 11.1113 14.1301 11.9999 14.9922Z",
    fill: "#FF8150"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.f736695b43db0855f94780771798fde8.svg";
export { ForwardRef as ReactComponent };